import React from 'react';
import { useGlobalization } from '@Translations/useGlobalization';

interface DriverScoreCellProps {
	value: unknown;
}

// A component the engine had no value for is omitted from WEIGHTED_SCORES
// (absent key), which is not the same as contributing 0 — show it as "—".
export const DriverScoreCell = ({ value }: DriverScoreCellProps) => {
	const { t } = useGlobalization();
	const n =
		value === null || value === undefined || value === ''
			? Number.NaN
			: Number(value);
	if (Number.isNaN(n)) {
		return (
			<span
				data-testid="driver-score-missing"
				role="img"
				aria-label={t('No value')}
				style={{ color: '#6b7280' }}>
				—
			</span>
		);
	}
	return <span>{n.toFixed(2)}</span>;
};
